import type {
    QuippySuggestedQuestion,
    QuippySuggestionCategory,
} from '../models';

export const CATEGORY_ICONS = {
    'Understand it': 'lucideLightbulb',
    'Keep it running': 'lucideSettings',
    'Manage risk': 'lucideShieldUser',
    'Meet obligations': 'lucideCircleCheckBig',
    'Find evidence': 'lucideSearch',
    'Coordinate people': 'lucideUsers',
    'Improve performance': 'lucideTrendingUp',
    'Assess value & use': 'lucideScale',
    'Plan change': 'lucideConstruction',
} as const satisfies Record<QuippySuggestionCategory, string>;

export interface PromptDefinition {
    readonly category: QuippySuggestionCategory;
    readonly building: string;
    readonly portfolio: string;
    readonly action: QuippySuggestedQuestion['action'];
}

export function prompt(
    category: PromptDefinition['category'],
    building: string,
    portfolio: string,
    action: PromptDefinition['action'] = 'submit'
): PromptDefinition {
    return { category, building, portfolio, action };
}
